<template>
  <section>
    <bannertitle link_href="/about">
      <template slot="tag">使用条款</template>
      <template slot="title">使用条款</template>
      <template slot="subtitle"></template>
    </bannertitle>
    <section class="banner_image">
      <div class="width_100">
        <picture class="width_100">
          <img src="@/assets/FFP/images/termsofuse-banner.png"
               alt="termsofuse-banner.png"
               class="width_100">
        </picture>
      </div>
    </section>
    <section class="about_company">
      <div class="content_container">
        <div class="paragraph">&nbsp;</div>
        <div class="paragraph"><span1 >请您在使用本网站前仔细阅读本使用条款，该使用条款中包含您作为本网站用户所享有的权利和义务等重要内容。当您有浏览、进入及使用本网站（如复制任何信息、注册成为网站用户等）之行为时，即表示您已同意接受本使用条款的全部内容，</span1>从而成为您与佳能商务科技（广东）有限公司（以下简称“佳能商务科技（广东）”）就使用本网站所做的双方合意约定。若您不同意，请停止使用本网站。</div>
        <div class="paragraph font_bold2">服务说明：</div>
        <div class="paragraph ">本网站仅为用户提供网络服务。您需要自行配备上网的所需设备（如个人电脑、手机、或其他必备上网装置）及所需费用（如上网所支付的与此服务有关的电话费用、 网络费用、手机费用等）。 基于佳能商务科技（广东）所提供的服务的重要性，您同意：</div>
        <div class="paragraph paraindent">（1）提供详尽、准确的个人资料。不断更新注册资料，符合及时、详尽、准确的要求；</div>
        <div class="paragraph paraindent">（2）对您在本网站发表的任何内容的真实性、合法性、有效性承担全部责任；</div>
        <div class="paragraph paraindent">（3）遵守所有适用的法律法规，若您在使用本网站时违反任何规定，佳能商务科技（广东）可自行判断要求您改正或采取一切必要的措施以减轻您的不当行为造成的影响。</div>
        <div class="paragraph font_bold2">用户名、用户密码和安全性</div>
        <div class="paragraph ">本网站可能会邀请您就本网站或本网站某项服务的使用进行身份注册，佳能商务科技（广东）完全尊重您自主决定是否进行身份注册。如果您选择进行身份注册，请您遵守本网站指示的其他条款和条件，包括但不限于注册条款。</div>
        <div class="paragraph ">您一旦注册成功并获得佳能商务科技（广东）分配的用户名和密码，应妥善保管该用户名和密码，不得将其转让或授予他人使用，并对以其用户名从事的一切活动承担责任。</div>
        <div class="paragraph ">如因保管疏忽、黑客攻击等原因导致用户名和密码遭他人非法使用的，佳能商务科技（广东）恕不承担责任，敬请谅解。若您发现您的用户名和密码遭他人非法使用，应立即通知佳能商务科技（广东）。</div>
        <div class="paragraph ">佳能商务科技（广东）同时保留无需任何理由随时终止您访问本网站的权利（包括收回其注册身份）。</div>
        <div class="paragraph font_bold2">隐私政策</div>
        <div class="paragraph ">保护用户个人信息是佳能商务科技（广东）的一项基本原则。佳能商务科技（广东）将按照本协议及《隐私政策》（链接地址：http://www.canon-bsg.com.cn/privacy-policy）的规定收集、使用、转让和共享您的个人信息。本协议对个人信息保护规定的内容与上述《隐私政策》有冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。</div>
        <div class="paragraph font_bold2">特别项目、功能和活动</div>
        <div class="paragraph ">本网站可能会提供某些特别项目、功能和活动（比如竞赛、抽奖或其他活动），除遵守本使用条款外，这些活动会(1)适用另行制定的使用规则、条款和/或政策；并(2) 由佳能商务科技（广东）或授权第三方提供。若您选择参与这些活动，即视为您同意参与活动适用另行制定的使用规则、条款和/或政策。</div>
        <div class="paragraph font_bold2">网站服务内容的知识产权：</div>
        <div class="paragraph ">本网站所有内容（包括但不限于文字、说明、图画、图片、图形、档案、页面设计、网站规划与安排等）之著作权及其他知识产权皆为佳能商务科技（广东）或其相关权利人所有。您不得以任何方式修改或者复制或者公开展示、公布或分发这些材料或者以其它方式把它们公开或用于商业目的。任何人未经书面授权，不得就本网站之内容享有任何权利。您不得对本网站内容之全部或部分进行下列行为，包括但不限于复制、储存、下载、使用、修改、改作、链接、公开播送、公开播映、传送、进行还原工程、解编或反向组译，如若有佳能商务科技（广东）或相关权利人事先书面许可，或本网站有其它授权及允许规定时，不在此限。</div>
        <div class="paragraph font_bold2">商标权之保护：</div>
        <div class="paragraph ">您对佳能或佳能关联企业拥有的商标、商号、标识、图案、佳能产品型号及名称、本网站的名称、域名或其衍生物（以下简称“佳能标识”）不拥有任何权利。本使用条款亦不授予您上述任何权利或权益。</div>
        <div class="paragraph ">本网站提及的其它产品或公司之名称，有可能是其它人之商标或企业表征。您不因进入及使用本网站即表示经明示或默示而有权使用出现在本网站的商标，除非您获得本公司或各该权利人之事先书面许可。</div>
        <div class="paragraph font_bold2">软件的使用：</div>
        <div class="paragraph ">如果您从本网站下载软件，使用软件要遵守随该软件携带的许可协议中的许可条款。在您阅读并且接受软件许可协议的各项条款之前建议不要下载或安装这一软件。</div>
        <div class="paragraph font_bold2">链接第三方Web网站：</div>
        <div class="paragraph ">本网站链接到第三方Web网站的链接仅作为一种方便服务提供给您，您可由本网站链接至第三人拥有或经营的网站。在链接并使用第三方网站时，请您先行阅读并决定是否同意该第三方网站之使用规定。由于佳能商务科技（广东）未审核过也无法完全审查所有相关第三方之网站，对任何这些网站及其内容不进行控制，也恕不承担责任，敬请谅解。因此，佳能商务科技（广东）对这些网站上的任何信息、软件及其它产品服务或材料，或者通过使用它们可能获得的任何结果不予认同亦未作任何陈述。如果您决定访问本站链接的任何第三方网站，其风险需要由您承担。您若认为第三方网站不适合您的需求，或不信任其内容，请您尽速离开该等网站。您在第三方网站上所进行之任何行为，包括但不限于买卖、赠与、抽奖、接受服务等，均与本公司无关，本公司亦声明绝不介入任何您与第三方网站间之任何行为，您在其他网站所为之行为若产生争议，请向该行为之相对人或服务提供者请求。</div>
        <div class="paragraph font_bold2">责任声明</div>
        <div class="paragraph ">您同意对使用佳能商务科技（广东）网络服务的行为和后果承担全部责任与风险，因您不当使用佳能商务科技（广东）网络服务、违反本条款或在您的账户名义下采取的一切行动，而导致的任何第三方索赔，需要由您本人承担。如果由此引起佳能商务科技（广东）及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并承担由此造成的全部责任。</div>
        <div class="paragraph ">本网站所载内容仅为便利您使用及了解佳能商务科技（广东）而设置。佳能商务科技（广东）将以现有及实时的网页内容供您个人非商业用途使用。在法律允许的范围内，佳能商务科技（广东）对由于使用本网站有关的任何间接的、偶然的或其他形式的损失（包括但不限于商业利润损失、业务中断或商业信息丢失）不承担责任，敬请谅解。</div>
        <div class="paragraph ">佳能商务科技（广东）不担保网络服务一定能满足您的要求，也不担保网络服务不会中断，对服务的及时性、安全性、准确性都不作担保。 对于因不可抗力或佳能商务科技（广东）不能避免或控制的原因造成的网络服务中断或其它缺陷，佳能商务科技（广东）恕不承担责任，但将尽力减少因此而给您造成的损失和影响。</div>
        <div class="paragraph font_bold2">注意事项</div>
        <div class="paragraph "><span1>本网站包含一部分广告/市场推广等内容，敬请知悉。</span1></div>
        <div class="paragraph "><span1>本网站将尽可能地提供准确的信息。本网站内所涉及的产品图片与实物可能有细微区别，效果演示图和示意图仅供参考，有关佳能产品的外观（包括但不限于颜色）请以实物为准。限于篇幅，本网站中所包含的信息（包括但不限于产品规格、功能说明等）可能不完整，请以有关产品使用说明书的具体信息为准。</span1></div>
        <div class="paragraph "><span1>本网站中产品介绍、技术规格等有关产品和服务的说明，是对佳能经营的产品和提供的服务进行的说明，仅限于佳能集团、佳能产品和服务的范围内，不存在与其他公司、其他产品和服务比较的情况。</span1></div>
        <div class="paragraph ">本网站可能展示由第三方制造商/供应商 (「第三方」) 制造及/或提供予佳能商务科技（广东）的产品/服务。相关产品受第三方提供、发布及授予的条款约束。除非本协议另有规定，并在适用法律允许的最大范围内，您在此同意有关第三方提供之任何保养是对相关产品任何故障、缺陷或失效的唯一保养，任何及所有与相关保养的申索仅与第三方（而非佳能商务科技（广东））相关。</div>
        <div class="paragraph font_bold2">服务的变更、中断或终止</div>
        <div class="paragraph ">鉴于网络服务的特殊性，佳能商务科技（广东）有权随时变更或中断或终止部分或全部网络服务，恕不对您或第三方负责。</div>
        <div class="paragraph ">如发生下列任何一种情形，佳能商务科技（广东）有权随时中断或终止向您提供网络服务而恕不对您或任何第三方承担责任：</div>
        <div class="paragraph paraindent">（1）您提供的资料不真实；</div>
        <div class="paragraph paraindent">（2）您发布的信息违反法律法规或侵犯第三人的合法权利；</div>
        <div class="paragraph paraindent">（3）您违反本条款的有关规定；</div>
        <div class="paragraph paraindent">（4）按照主管部门的要求；</div>
        <div class="paragraph paraindent">（5）您利用本网站服务实施违法行为或有违良好道德风尚或公序良俗的行为或活动。</div>
        <div class="paragraph font_bold2">服务条款的变更和修订</div>
        <div class="paragraph ">佳能商务科技（广东）有限公司有权随时修改本协议之任一条款，并有权以消息推送、网页公告等方式予以公布，而无需另行单独通知您，您需要经常访问该页面以及时了解当前的条款，这些条款的某些条文也可能被位于本站中的某些页面明确指定的法律通告或条款所取代。若您在本使用协议条款内容公告变更后继续使用本网站服务，则表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的条款内容使用本网站服务；若您不同意修改后的服务条款，请您立即停止使用本网站服务。</div>
        <div class="paragraph font_bold2">法律适用与管辖</div>
        <div class="paragraph ">本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</div>
        <div class="paragraph ">如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，<span1>任何一方均可向位于深圳市的深圳国际仲裁院（深圳仲裁委员会），依其当时有效的仲裁规则申请仲裁。仲裁裁决是终局的，对双方均具有约束力。</span1></div>
        <div class="paragraph">&nbsp;</div>
      </div>
      <div></div>
    </section>
    <learnmore :option="learn_option">
      <template slot="line_one">了解更多佳能产品及解决方案</template>
      <template slot="learn_more_button">联络我们</template>
    </learnmore>
  </section>
</template>
<script>
import bannertitle from './bannertitle'
import learnmore from '../LearnMore'
export default {
  name: 'CompanyProfile',
  components: { bannertitle, learnmore },
  props: [
    'belongTo'
  ],
  data () {
    return {
      learn_option: {
        backgroundColor: '#505050',
        fontColor: 'white'
      }
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss" src='../../assets/FFP/css/Article.scss'>
</style>
<style scoped lang="scss">
$p-size: 32px;
$p-size-small: 24px;
$span-size: 20px;
$span-size-small: 16px;
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

.banner_image {
  width: 100%;
}
.width_100 {
  width: 100%;
}

.width_50 {
  width: 50%;
}

.background_color_gray {
  background-color: #ebebeb;
}
.background_color_white {
  background-color: #ffffff;
}
.about_company {
}
.about_company .article_contioner {
  width: 100%;
  padding: 100px 300px;
}

.about_company .article_image {
  background: linear-gradient(
    #ffffff 0%,
    #ffffff 29%,
    #ffffff 30%,
    #eceded 30%,
    #ebebeb 100%
  );
}
.about_company .article_image img {
  width: 50%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.about_company .article_contioner .article_title {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 50px;
}
.about_company .article_contioner .article_text {
  font-size: 24px;
  font-weight: 600;
  color: #414141;
}
.about_company .article_contioner .article_text p {
  margin-bottom: 20px;
}

@media (min-width: 544px) and (max-width: 1200px) {
  .about_company .article_contioner {
    padding: 80px 100px;
  }
  .about_company .article_image img {
    width: 70%;
  }
}

@media (max-width: 544px) {
  .about_company .article_contioner {
    padding: 20px 40px;
  }
  .about_company .article_image img {
    width: 70%;
  }
  .about_company .article_contioner .article_title {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .about_company .article_contioner .article_text {
    font-size: 18px;
  }
}

.milestone_title {
  margin: 100px;
  font-size: 36px;
  font-weight: 600;
  text-align: center;
}

@media (max-width: 544px) {
  .milestone_title {
    margin: 40px;
    font-size: 24px;
  }
}

.milestone {
  position: relative;
  width: 75%;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 1200px) {
  .milestone {
    width: 90%;
  }
}

.milestone_line {
  position: absolute;
  left: 9px;
  height: 100%;
  border-left: 2px solid #f2524e;
}
.milestone_item {
  position: relative;
  padding-top: 20px;
}

.milestone_time {
  font-size: 36px;
  color: #f2524e;
  position: relative;
  top: 0px;
  left: -5px;
  background-color: #ffffff;
  margin: 10px 10px 10px 0;
}

.milestone_circle {
  height: 20px;
  width: 20px;
  border: 2px solid #f2524e;
  border-radius: 50%;
  position: absolute;
  top: 30%;
  background-color: #ffffff;
}
.milestone_image img {
  height: 200px;
}

@media (min-width: 544px) and (max-width: 768px) {
  .milestone_image img {
    height: 150px;
  }
}

@media (max-width: 544px) {
  .milestone_image img {
    height: 80px;
  }
}
.milestone_article {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ebebeb;
  margin: 0 100px;
}

@media (min-width: 544px) and (max-width: 1200px) {
  .milestone_article {
    margin: 0 50px;
  }
}

@media (max-width: 544px) {
  .milestone_article {
    margin: 0 30px;
  }
}

.milestone_article .milestone_text {
  font-size: 24px;
  margin-left: 50px;
}

@media (min-width: 544px) and (max-width: 768px) {
  .milestone_article .milestone_text {
    font-size: 18px;
    margin-left: 20px;
  }
}
@media (max-width: 544px) {
  .milestone_article .milestone_text {
    font-size: 14px;
    margin-left: 10px;
  }
}
.font_size_32px {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Article/TermOfUse.vue